<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<div class="col-lg-12">
				<div class="card card-primary card-outline">
					<div class="card-header">
						
					</div>
					<div class="card-body overflow-auto">
            <h3>{{campaign.id}}</h3>{{campaign.short_code}}
            <p>Criteria:</p><h5>{{campaign.criteria}}</h5>
						{{campaign}}
						
					</div>
					<div class="card-footer">
						<div class="row">
              <div class="col-md-6">
                <qrcode-vue :value="value" :size="size" level="H" />
              </div>
              <div class="col-md-6">
                <h5>Campaign URL: </h5>
                <h3>{{value}}</h3>
                <button class="btn btn-danger" @click="categories">Categories</button>
						    <button class="btn btn-danger" @click="rules">Rules</button>
						    <button class="btn btn-danger" @click="registrations">Registrations</button>
						    <button class="btn btn-danger" @click="allotments">Allotments</button>
              </div>
              <div class="col-md-6">
              	<button class="btn btn-danger" @click="endPrompt">End Campaign</button>
              </div>
            </div>
					</div>
				</div>
			</div>
    </section>
    <!-- /.content -->

<div class="modal" tabindex="-1" role="dialog" id="endmodal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">End Campaign</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <h4>Are you sure you want to end this campaign?</h4>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" @click="end">Yes</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>
<!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
import QrcodeVue from "qrcode.vue/dist/qrcode.vue";

		 export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        created(){
        	this.getCampaign();
        },
        
        data(){
        	return {
        		campaign: {},
            value: "www.oxygendigitalshop.com",
            size: 200
        	}
        },

        components: {
          QrcodeVue,
          },
        
        methods: {
        	getCampaign(){
        		axios.post("/api/getGiftCampaign", {id: this.$route.params.id})
        		.then(response => {
        			this.campaign = response.data;
              this.value = 'https://www.oxygendigital.expert/gift-registration/'+ this.campaign.short_code
        		});
        	},
        	
        	rules(){
        		this.$router.push('/gift/rules/'+this.$route.params.id);
        	},
        	
        	registrations(){
          	this.$router.push('/gift/registrations/'+this.$route.params.id);
          },
        	
        	allotments(){
            this.$router.push('/gift/allotments/'+this.$route.params.id);
          },
        	
        	categories(){
            this.$router.push('/gift/categories/'+this.$route.params.id)
          },
          
          endPrompt(){
          	$("#endmodal").modal("show");
          },
          
          end(){
          	axios.post("/api/endGiftCampaign", {id: this.campaign.id})
          	.then(response => {
          		toast.fire({
          			icon: 'success',
          			title: 'Campaign Ended'
          		});
          		this.getCampaign();
          		$("#endmodal").modal("hide");
          	});
          }
        }
    }
</script>
